import React from 'react'

const posterUrl = (image, video) => {
  if (image) return image
  if (video.service === 'youtube') return `https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`
  return null
}

// Stand-in for a video that isn't the current slide (or is a react-slick clone).
const VideoPoster = ({ image, video, title }) => {
  const src = posterUrl(image, video)

  return (
    <div className='absolute inset-0 flex items-center justify-center bg-gray-900 dark:bg-gray-900'>
      {src && <img src={src} alt={title || ''} className='absolute inset-0 w-full h-full object-cover' />}
      <div className='relative rounded-full bg-black/60 dark:bg-black/60 p-4 text-white dark:text-white'>
        <svg className='w-8 h-8 sm:w-10 sm:h-10' fill='currentColor' viewBox='0 0 24 24' aria-hidden='true'>
          <path d='M8 5v14l11-7z' />
        </svg>
      </div>
    </div>
  )
}

export default VideoPoster
